import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { ProviderIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { useRef } from 'react'
import { toast } from 'sonner'

import { createOl } from '../../api/ols/create-ol'
import UserNavBar from '../../components/elements/nav-bar'
import OlForm from '../../components/pages/ols/ol-form'
import { Paths } from '../../lib/constants/path'
import { GenderEnum } from '../../lib/types/enums/common/gender.enum'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'
import { constructOlPath } from './views/utils'

const OlCreatePage = () => {
  const { navigate, back } = useNavigator()
  const ref = useRef(null)

  const { mutateAsync } = useMutation({
    mutationFn: createOl,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Prestataire créé avec succès')
      // Scroll to top of the page using the ref top-page
      const topPage = ref.current as HTMLElement | null
      if (topPage) {
        topPage.scrollIntoView({ behavior: 'smooth' })
      }
    }
  })

  return (
    <div ref={ref}>
      <UserNavBar title={'Créer un prestataire'} icon={ProviderIcon} />
      <div className={'h-4'} />

      <Box>
        <div className={'h-4'} />

        <OlForm
          defaultValues={{ isActive: true, mainContactGender: GenderEnum.MALE }}
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(constructOlPath(Paths.OL_DETAILS_UPDATE_PAGE, res.id), { replace: true })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default OlCreatePage
